import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=ee8a7f12&scoped=true&"
import script from "./Close.vue?vue&type=script&lang=js&"
export * from "./Close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a7f12",
  null
  
)

export default component.exports